import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import Homepage from "../Slides/HomepageSlide";
import WelcomeSlide from "../Slides/WelcomeSlide";

function Home({ ...rest }) {
  const { isAuthenticated, user } = useAuth0();
  return isAuthenticated ? <Homepage {...rest} /> : <WelcomeSlide {...rest} />;
}

export default Home;
